import axios from 'axios';
import { getToken, getTokenHeader } from '../../../../screen/auth/action';

import {
  AllCityUrl,
  GetMeUrl,
  GetUserFiles,
  GstUserGstDataFetchUrl,
  GstUserPanDataFetchUrl,
  LoginOtpUrl,
  LoginUrl,
  LogoutUrl,
  RegisterUrl,
  SendOTPByPhoneUrl,
  SetNewPasswordUrl,
  addManufacturerRoleToExistingFirmUrl,
  getBuyerRolesUrl,
  getCompanyAndRoleUrl,
  getOnboardingIndustryUrl,
  onboardFirmUrl,
  onboardThroughExistingUserUrl,
  sendOtpForSignUpUrl,
  updateTokenUrl,
  verifySignUpOtpUrl,
  getLocationAndPincodeUrl,
  getpricingGeographyUrl,
} from '../api';
import { Buffer } from 'buffer';

export const LoginAction = async (payload) => {
  return new Promise(async (next) => {
    await axios
      .post(LoginUrl(), payload)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch(function (error) {
        console.log('error', error);
      });
  });
};
export const SendOTPByPhoneNow = async (phone_number) => {
  return new Promise(async (next) => {
    await axios
      .get(`${SendOTPByPhoneUrl()}?phone_number=${phone_number}`)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const sendOtpForSignUpAction = async (mobile_number, tnc) => {
  return new Promise(async (next) => {
    await axios
      .post(sendOtpForSignUpUrl(), {
        phone_number: mobile_number,
        privacy_policy_accept_status: tnc,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const verifySignUpOtpAction = async (payload) => {
  return new Promise(async (next) => {
    await axios
      .post(verifySignUpOtpUrl(), payload)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const LoginOtpAction = async (phone_number, otp) => {
  return new Promise(async (next) => {
    await axios
      .post(`${LoginOtpUrl()}?phone_number=${phone_number}&otp=${otp}`)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch(function (error) {
        console.log('error', error);
      });
  });
};
export const SetNewPassword = async (payload) => {
  return new Promise(async (next) => {
    await axios
      .post(SetNewPasswordUrl(), payload)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch(function (error) {
        return next(error);
      });
  });
};
export const RegisterNow = async (payload) => {
  return new Promise(async (next) => {
    await axios
      .post(RegisterUrl(), payload)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const getOnboardingIndustryAction = async (id) => {
  let url = getOnboardingIndustryUrl();

  if (id) url = `${url}?primary_industry_type=${id}`;

  return new Promise(async (next) => {
    await axios
      .get(url)
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getCompanyAndRoleAction = async (payload) => {
  const params = new URLSearchParams(payload);
  const token = await getToken();
  return new Promise(async (next) => {
    await axios
      .get(`${getCompanyAndRoleUrl()}`, {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getBuyerRolesAction = async (
  supplier_id,
  is_Ship_To_Party = false,
  is_sell_to_buyer = false,
  is_performance_module = false,
) => {
  const token = await getToken();
  return new Promise(async (next) => {
    await axios
      .get(
        `${getBuyerRolesUrl()}?supplier_id=${supplier_id}&is_ship_to_party=${is_Ship_To_Party}&is_sell_to_buyer=${is_sell_to_buyer}&is_performance_module=${is_performance_module}`,
        {
          ...getTokenHeader(token),
        },
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
// onboading Gst fetch for details
export const GstUserGstDataFetch = async (gst) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(`${GstUserGstDataFetchUrl()}?gstin=${gst}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

// onboading PAN fetch for details
export const GstUserPanDataFetch = async (pan) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(`${GstUserPanDataFetchUrl()}?pan_no=${pan}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

//Gstin Details
export const getGstDetails = async (Gst_no) => {
  return new Promise(async (next) => {
    // let regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i;
    // let findVal = regex.exec(Gst_no);
    // if (findVal === null) {
    //   return next({
    //     error: true,
    //     data: [],
    //     message: 'Enter Valid GSTIN Number',
    //   });
    // }
    const { data, error, message } = await GstUserGstDataFetch(Gst_no);

    let obj = {};

    if (!error) {
      obj = {
        firstname: Array.isArray(data.directors)
          ? data?.directors && data?.directors[0]?.split(' ')[0]
          : null,
        lastname: Array.isArray(data.directors)
          ? data?.directors &&
            data?.directors[0]?.trim().replace(/\s+/g, ' ').split(' ')
              .length === 3
            ? data?.directors[0]?.trim().replace(/\s+/g, ' ').split(' ')[2]
            : data?.directors[0]?.trim().replace(/\s+/g, ' ').split(' ')[1]
          : null,
        company_name: data?.trade_name,
        pancard_no: data?.pan,
        gst_no: Gst_no,
        street: data?.principal_address?.address,
        phone_number: data?.principal_address?.mobile,
        company_pincode: data?.principal_address.pincode,
        document_type: data.document_type,
        document_id: data.document_id,
        state_name: data?.principal_address?.state_name,
        state_id: data?.principal_address?.state_id,
        district_name: data?.principal_address?.district_name,
        district_id: data?.principal_address?.district_id,
        address_line_1: data?.principal_address?.address_line_1,
        address_line_2: data?.principal_address?.address_line_2,
        address_line_3: data?.principal_address?.address_line_3,
        pincode_id: data?.principal_address?.pincode_id,
        pincode_name: data?.principal_address?.pincode_name,
      };
    }

    return next({
      error: error,
      data: obj,
      message: message,
    });
  });
};

//PAN Details
export const getPanDetails = async (pancard_no) => {
  return new Promise(async (next) => {
    // let regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i;
    // let findVal = regex.exec(pancard_no);
    // if (findVal === null) {
    //   return next({
    //     error: true,
    //     data: [],
    //     message: 'Enter Valid PAN Number',
    //   });
    // }
    const { data, error, message } = await GstUserPanDataFetch(pancard_no);

    let obj = {};

    if (!error) {
      obj = {
        firstname: data?.first_name,
        lastname: data?.last_name,
        company_pincode:
          data?.address_data &&
          data?.address_data?.pincode &&
          data?.address_data?.pincode,
        street: data && data.address_data && data.address_data.line_1,
        phone_number: data.phone ? data.phone : null,
        document_type: data.document_type,
        document_id: data.document_id,
        gst_no: null,
        pancard_no: pancard_no,
        state_name: data?.address_data?.state,
        state_id: data?.address_data?.state_id,

        district_name: data?.address_data?.city,
        district_id: data?.address_data?.district_id,
      };
    }

    return next({
      error: error,
      data: obj,
      message: message,
    });
  });
};

export const GetAllCityOfState = async (stateId) => {
  return new Promise(async (next) => {
    let token = await getToken();
    let params = { params: {} };
    if (token) {
      params = { params: {}, ...getTokenHeader(token) };
    } else {
      params = { params: {} };
    }

    await axios
      .get(`${AllCityUrl()}/${stateId}`, params)
      .then(async ({ data: x }) => {
        return next(x);
      })
      .catch(function (error) {
        next({ error: error });
      });
  });
};
export const GetMeAction = async () => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(GetMeUrl(), { params: {}, ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetUserFilesNow = async (userId, fileType) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const imageUrl = `${GetUserFiles()}/${userId}/${fileType}`;

    await axios
      .get(imageUrl, {
        ...getTokenHeader(token),
        responseType: 'arraybuffer',
      })
      .then((response) => {
        let data = `data:${
          response.headers['content-type']
        };base64,${Buffer.from(response.data, 'binary').toString('base64')}`;
        return next(data);
      })
      .catch((error) => {
        return next({ error: error });
      });
  });
};

export const getProfilePicture = (profilePictureData) => {
  let data = `data:${profilePictureData?.media_type};base64,${profilePictureData?.file_data}`;
  return data;
};

export const onboardFirmAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(onboardFirmUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const logoutAction = async () => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(LogoutUrl(), { params: {}, ...getTokenHeader(token) })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        console.log(err);
        return next({ error: err });
      });
  });
};
export const updateTokenAction = async ({ company_id }) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${updateTokenUrl()}?company_id=${company_id}`,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const refreshTokenAction = async (params) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(updateTokenUrl(), {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const addManufacturerRoleToExistingFirmAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(addManufacturerRoleToExistingFirmUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const onboardThroughExistingUser = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(onboardThroughExistingUserUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const editManufacturerRoleToExistingFirmAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .put(addManufacturerRoleToExistingFirmUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getLocationAndPincodeAction = async (id, params = {}) => {
  return new Promise(async (next) => {
    await axios
      .get(`${getLocationAndPincodeUrl()}?district_id=${id}`, { params })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getpricingGeographyAction = async (params) => {
  return new Promise(async (next) => {
    await axios
      .get(getpricingGeographyUrl(), { params })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
